<template>
  <div class="hotel-card">
    <div class="ws-textbox">
      <h5>
        <span v-if="isAfter">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_1 }}:</span> {{ hotelInfo.name }}
      </h5>
      <div class="galary-item">
        <div class="carousel slide" data-ride="carousel">
          <div class="carourel_hotel">
            <carousel
              id="hotelCardCarousel"
              :per-page="1"
              :pagination-enabled="false"
              loop
              :mouse-drag="false"
              autoplay
              :autoplay-timeout="5000"
              :autoplay-hover-pause="true"
              aria-label="Hotel photos"
              aria-roledescription="carousel"
            >
              <template
                v-if="
                  hotelInfo.image1_url ||
                  hotelInfo.image2_url ||
                  hotelInfo.image3_url ||
                  hotelInfo.img1 ||
                  hotelInfo.img2 ||
                  hotelInfo.img3
                "
              >
                <slide
                  v-if="hotelInfo.image1_url || hotelInfo.img1"
                  class="image_carousel"
                  :aria-label="hotelInfo.name + `- Photo 1`"
                >
                  <img :src="hotelInfo.image1_url || hotelInfo.img1" :alt="hotelInfo.name + ' - Photo 1'" @error="imgDefault" />
                </slide>
                <slide
                  v-if="hotelInfo.image2_url || hotelInfo.img2"
                  class="image_carousel"
                  :aria-label="hotelInfo.name + `- Photo 2`"
                >
                  <img :src="hotelInfo.image2_url || hotelInfo.img2" :alt="hotelInfo.name + ' - Photo 2'" @error="imgDefault" />
                </slide>
                <slide
                  v-if="hotelInfo.image3_url || hotelInfo.img3"
                  class="image_carousel"
                  :aria-label="hotelInfo.name + `- Photo 3`"
                >
                  <img :src="hotelInfo.image3_url || hotelInfo.img3" :alt="hotelInfo.name + ' - Photo 3'" @error="imgDefault" />
                </slide>
              </template>
              <slide v-else>
                <img :src="hotelImageDefault" alt="No hotel image available" aria-label="No hotel image available" />
              </slide>
            </carousel>
          </div>
        </div>
      </div>
      <div v-if="!isAfter" class="content__before">
        <div class="content">
          <div class="hotel-distance pb-1" dir="auto">
            <i class="fa fa-map-marker-alt" aria-hidden="true"></i>
            <span class="sr-only">Distance:</span>
            <span
              v-if="
                Number.isFinite(parseFloat(hotelInfo.road_distance_airport)) ||
                Number.isFinite(parseFloat(hotelInfo.distance_between))
              "
            >
              {{
                formatDistance(
                  Number.isFinite(parseFloat(hotelInfo.distance_between)) && parseFloat(hotelInfo.distance_between) > 0
                    ? parseFloat(hotelInfo.distance_between)
                    : Number.isFinite(parseFloat(hotelInfo.road_distance_airport)) &&
                      parseFloat(hotelInfo.road_distance_airport) > 0
                    ? parseFloat(hotelInfo.road_distance_airport)
                    : 0.0
                )
              }}
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_82 ?? 'KM' }}
              <span v-if="!getOptionTaxi"> {{ lang['hotel_mobile_new'].SFS_LANG_ROW_83 ?? 'from the airport' }} </span>
              <span v-else>
                {{ getOptionTaxi }}
              </span>
            </span>
            <span v-else-if="!hotelInfo.road_distance_airport || !hotelInfo.distance_between" class="ml-2">Unknown</span>
            <div v-if="isShowGGMap" class="pick-up-time">
              <label for="pick-up-time-display" class="mr-4 mb-0">Pick up time:</label>
              <span
                v-b-modal.pick-up-time
                role="button"
                tabindex="0"
                aria-label="Select pick up time"
                class="pick-up-time__value"
              >
                {{ timePickup['HH'] + ':' + timePickup['mm'] }}
              </span>
              <div class="pick-up-time__modal">
                <b-modal id="pick-up-time" centered hide-footer hide-header-close hide-header>
                  <PopupPickTime :time-pickup="timePickup" @confirmPickUpTime="handlePickTime" />
                </b-modal>
              </div>
            </div>
          </div>
          <div v-if="sortDescription" class="hotel-description" v-html="sanitizeHtml(hotelInfo.description_en_GB)"></div>
          <div class="hotel-features">
            <span v-if="hotelOtherServices.handicapped" class="hotel-feature">
              <span class="hotel-feature-icon disabled"><i class="fa fa-wheelchair" aria-hidden="true" /></span>
              <span class="hotel-feature-text">Accessible rooms</span>
            </span>
            <span v-if="hotelOtherServices.dog" class="hotel-feature">
              <span class="hotel-feature-icon pets"><i class="fa fa-dog" aria-hidden="true" /></span>
              <span class="hotel-feature-text">Pets allowed</span>
            </span>
            <span v-if="hotelOtherServices.freewifi" class="hotel-feature">
              <span class="hotel-feature-icon wifi"><i class="fa fa-wifi" aria-hidden="true" /></span>
              <span class="hotel-feature-text">Free wifi</span>
            </span>
            <span v-if="hotelOtherServices.baby" class="hotel-feature">
              <span class="hotel-feature-icon baby"><i class="fa fa-child" aria-hidden="true" /></span>
              <span class="hotel-feature-text">Baby cots available</span>
            </span>
          </div>
        </div>
        <div class="hotel-horizontal"></div>
        <div v-if="!isShowGGMap">
          <div class="hotel-button-see-more">
            <a href="javascript:" role="button" aria-label="sort description" @click="sortDescription = !sortDescription">
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_15 }}
            </a>
          </div>
          <div class="hotel-button-select">
            <a
              href="javascript:"
              role="button"
              :aria-label="'select' + hotelInfo.name"
              class="btn btn-select"
              @click="handleBookHotel()"
            >
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_16 }}
            </a>
          </div>
        </div>
        <div v-if="isShowGGMap" class="hotel-map text-center">
          <div>
            <a
              href="javascript:"
              role="button"
              aria-label="See more"
              class="hotel-button-see-more"
              @click="isSeeMoreShowMap = !isSeeMoreShowMap"
              >Show map</a
            >
          </div>
          <div v-if="isSeeMoreShowMap" class="map">
            <div>
              <WalkingMap :origin="origin" :is-show-map="isShowMap" :destination="destination" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="isAfter" class="content__after">
        <div class="content">
          <div class="content__hotel-info">
            <div class="hotel-information">
              <div class="d-flex">
                <h5>{{ hotelInfo.name }}</h5>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_2 }}:</span>
                <span>
                  <a
                    :href="'http://maps.google.com/?q=' + getAddressHotel"
                    target="_blank"
                    rel="noopener noreferrer"
                    :aria-label="`View ${getAddressHotel} on Google Maps (opens in new window)`"
                  >
                    {{ getAddressHotel }}
                  </a>
                </span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_3 }}:</span>
                <span class="text-truncate">
                  <a
                    :href="
                      'tel:' + hotelPhoneNumber
                    "
                    class="phone-number"
                    :aria-label="
                      'Hotel phonenumber: ' +
                      hotelPhoneNumber
                    "
                    >{{ hotelPhoneNumber }}</a
                  >
                </span>
              </div>
              <div class="d-flex">
                <span
                  class="prefix mr-1 for-person"
                  v-html="
                    lang['hotel_mobile_new']?.SFS_LANG_ROW_71 &&
                    sanitizeHtml(applyTextReplacements(lang['hotel_mobile_new'].SFS_LANG_ROW_71))
                  "
                ></span>
                <span class="text-truncate">{{ hotelInfo.name_pax_group }}</span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_5 }}:</span>
                <span class="text-truncate">{{ hotelInfo.num_day }}</span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_4 }}:</span>
                <span>{{ checkinInfo }}</span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_81 }}:</span>
                <span>{{ checkoutInfo }}</span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_6 }}:</span>
                <span class="text-truncate" v-html="sanitizeHtml(getRoomType)"></span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_7 }}:</span>
                <span class="text-truncate">{{ hotelInfo.code }}</span>
              </div>
              <div v-if="hotelInfo.ws_reference" class="d-flex">
                <!-- Block reference: 169469579 -->
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_9 }}:</span>
                <span class="text-truncate">{{ hotelInfo.ws_reference }}</span>
              </div>
              <div v-else class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_8 }}:</span>
                <span class="text-blockcode">{{ getBlockCode }}</span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_10 }}:</span>
                <span class="text-truncate">{{
                  hotelInfo.ws_booking && hotelInfo.ws_booking?.BookingReference ? 'HRS' : 'SFS360'
                }}</span>
              </div>
              <div v-if="!hotelInfo.ws_reference" class="d-flex">
                <span class="prefix mr-1"
                  >{{ lang['hotel_mobile_new'].SFS_LANG_ROW_74 ? lang['hotel_mobile_new'].SFS_LANG_ROW_74 : 'Debit' }}:</span
                >
                <span class="text-truncate">{{ airline.airline_name }}</span>
              </div>

              <div v-if="hotelInfo.ws_booking && hotelInfo.ws_booking?.BookingReference">
                <!-- Reservation Number: 293618210 -->
                <p class="text-underline">
                  <span>{{ lang['hotel_mobile_new'].SFS_LANG_ROW_76 || 'Reservation Number' }}: </span>
                  <span>{{ hotelInfo.ws_booking?.BookingReference }}</span>
                </p>
              </div>

              <div
                v-if="hotelInfo.ws_booking && hotelInfo.ws_booking?.BookingReference"
                style="padding: 15px; background: #00000022; margin: 15px 0 30px"
              >
                <div
                  v-if="lang['hotel_mobile_new'] && lang['hotel_mobile_new'].SFS_LANG_ROW_77"
                  v-html="sanitizeHtml(lang['hotel_mobile_new'].SFS_LANG_ROW_77 || defaultExplainHRSPayment)"
                ></div>

                <div
                  v-if="hotelInfo.ws_booking && hotelInfo.ws_booking?.BookingReference"
                  class="d-flex justify-content-center align-items-center mt-4"
                >
                  <a
                    :href="`tel: ${hotelInfo.phone_number_hrs_support || '+492212077600'}`"
                    class="btn btn-call-hrs-support"
                    style="background: white"
                  >
                    <i class="fa fa-phone" aria-hidden="true"></i>
                    {{ lang['hotel_mobile_new'].SFS_LANG_ROW_78 || 'Click here to call hotel support' }}
                  </a>
                </div>
              </div>

              <div
                v-if="hotelInfo.ws_booking && hotelInfo.ws_booking?.BookingReference"
                style="
                  border: 5px solid black;
                  border-radius: 10px;
                  padding: 15px;
                  background: white;
                  box-shadow: 0 0 10px #00000066;
                "
              >
                <div style="text-align: center">
                  <div><img src="/images/hrs.png" style="max-width: 72px" /></div>
                  <div style="font-weight: lighter; text-transform: uppercase; color: black; letter-spacing: 0.05rem">
                    Booking Confirmation
                  </div>
                </div>

                <div
                  style="
                    line-height: 1.5rem;
                    font-size: 1rem;
                    padding: 10px 15px;
                    margin: 10px -15px;
                    border-top: 1px solid black;
                    border-bottom: 1px solid black;
                    background: #00000011;
                    box-shadow: 0 0 10px #00000044;
                  "
                  v-html="sanitizeHtml(applyTextReplacements(lang['hotel_mobile_new'].HRS_MESSAGE_FOR_HOTEL))"
                ></div>

                <!--

                    <div style="margin-bottom: 8px;">
                      Attention <strong style="color: #EB004B;">{{ hotelInfo.name }}</strong>:
                    </div>
                    <div style="margin-bottom: 8px;">
                      <strong style="color: #EB004B;">{{ airline.airline_name }}</strong> has booked a room through our booking partner <strong style="color: #EB004B;">HRS</strong>.
                    </div>
                    <div>
                      Please login to your myHRS portal for more information and refer to the following information for booking details:
                    </div>
                    -->

                <p class="">
                  <span class="prefix mr-1">{{ lang['hotel_mobile_new'].BOOKING_PARTNER || 'Booking Partner' }}: </span>
                  <span>HRS</span>
                </p>
                <p class="">
                  <span class="prefix mr-1">{{ lang['hotel_mobile_new'].HOTEL_PHONE_NUMBER || 'Hotel Phone Number' }}: </span>
                  <span style="white-space: none">{{ hotelPhoneNumber }}</span>
                </p>

                <p class="">
                  <span class="prefix mr-1">{{ lang['hotel_mobile_new'].PASSENGER_NAME || 'Passenger Name' }}: </span>
                  <span>{{ hotelInfo.name_pax_group }}</span>
                </p>
                <p class="">
                  <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_76 || 'Reservation Number' }}: </span>
                  <span>{{ hotelInfo.ws_booking?.BookingReference }}</span>
                </p>
                <p class="">
                  <span class="prefix mr-1">{{ lang['hotel_mobile_new'].PROCESS_NUMBER || 'Process Number' }}: </span>
                  <span>{{ hotelInfo.ws_booking?.reservationProcessKey }}</span>
                </p>
                <p class="">
                  <span class="prefix mr-1">{{ lang['hotel_mobile_new'].ACCESS_CODE || 'Access Code' }}: </span>
                  <span>{{ hotelInfo.ws_booking?.reservationProcessPassword }}</span>
                </p>
                <p class="">
                  <span class="prefix mr-1">{{ lang['hotel_mobile_new'].CREDIT_CARD || 'Credit Card' }}: </span>
                  <span
                    ><br />MasterCard **** **** **** {{ hotelInfo.ws_booking?.reservationInformation?.cardNumber }}
                    <span style="white-space: nowrap"
                      >(exp {{ hotelInfo.ws_booking?.reservationInformation?.cardExpirationDate }})</span
                    ></span
                  >
                </p>

                <p class="">
                  <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_4 || 'Check in' }}: </span>
                  <span>{{ checkinInfo }}</span>
                </p>
                <p class="">
                  <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_81 || 'Check out' }}: </span>
                  <span>{{ checkoutInfo }}</span>
                </p>

                <div style="line-height: 1.5rem; margin-top: 5px">
                  <div class="prefix">{{ lang['hotel_mobile_new'].RESERVATION_EMAILED_TO || 'Reservation emailed to' }}:</div>
                  <div style="font-size: 1rem">
                    {{
                      hotelInfo.ws_booking?.reservationInformation?.emailAddress
                        ? hotelInfo.ws_booking?.reservationInformation?.emailAddress
                        : hotelInfo.name
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="isCheckBlockDate && hotelInfo.transport_available == 1 && hotelInfo.transport_id == 1"
              class="shuttle-bus-infor"
            >
              <div class="prefix">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_11 }} {{ flightDate || 'Today' }}</div>
              <div v-for="(blockDate, index) in getBlockDate" :key="index">
                <span v-if="blockDate.operating_opentime && blockDate.operating_closetime" class="mr-4 blockdate">
                  {{ blockDate.operating_opentime }} - {{ blockDate.operating_closetime }}
                </span>
                <span v-if="blockDate.frequency_service"> every {{ blockDate.frequency_service }} min </span>
              </div>
              <div v-if="hotelInfo.pickup_details">
                <div class="prefix">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_70 }}</div>
                <span class="line-original">{{ hotelInfo.pickup_details }}</span>
              </div>
            </div>
            <div v-if="hotelInfo.transport_available == 2">
              <div v-if="hotelInfo.desc_direction_hotel">
                <div class="prefix">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_70 }}</div>
                <span class="line-original">{{ hotelInfo.desc_direction_hotel }}</span>
              </div>
            </div>

            <!-- comment & internal_info -->
            <div v-if="hotelInfo.comment" class="mb-4 mt-4">
              <div class="prefix">{{ lang['hotel_mobile_new']?.SFS_LANG_ROW_80 || 'Note from airline' }}</div>
              <p v-if="hotelInfo.comment" class="hotel-comment" v-html="linkify(hotelInfo.comment)"></p>
            </div>

            <router-link
              v-if="showCancelHotel && !hasCancelHotelVoucher"
              class="text-cancel-hotel pt-3 cursor-pointer"
              :to="{ name: 'CancelHotelRoom', query: { secret: secret, ctime: cancelTime } }"
            >
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_12 }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import WalkingMap from '@/components/Map/index'
import PopupPickTime from '@/components/PopupPickTime/index'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { linkify, replaceStr, sanitizeHtml } from '@/utils/helper'
import { ROOM_TYPE_MAPPING } from '@/constants/hotel'

export default {
  name: 'HotelCard',
  components: {
    WalkingMap,
    PopupPickTime
  },
  props: {
    hotelInfo: {
      type: Object,
      default: () => {}
    },
    isShowGGMap: {
      type: Boolean,
      default: false
    },
    isAfter: {
      type: Boolean,
      default: false
    },
    cancelTime: {
      type: String,
      default: ''
    },
    showCancelHotel: {
      type: Boolean,
      default: false
    },
    hasCancelHotelVoucher: {
      type: Boolean,
      default: false
    },
    origin: {
      type: Object,
      default: () => {}
    },
    destination: {
      type: Object,
      default: () => {}
    },
    timePickup: {
      type: Object,
      default: () => {}
    },
    listDataBooking: {
      type: Array,
      default: () => []
    },
    checkinDate: {
      type: Date,
      default: null
    },
    checkoutDate: {
      type: Date,
      default: null
    }
  },
  data() {
    return {
      hotelImageDefault: this.$publicPath + 'images/No_Image_Available.jpg',
      sortDescription: false,
      isShowMap: false,
      isSeeMoreShowMap: false,
      day: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      flightDate: '',
      secret: this.$route.query.secret,
      defaultExplainHRSPayment:
        'HRS has made the reservation and payment for your hotel booking. Should the hotel require any more information, please mention the reservation number stated above or ask the hotel to contact the HRS customer service.'
    }
  },
  computed: {
    ...mapGetters({
      voucher: 'Taxi/Voucher',
      direction: 'direction',
      airline: 'airline'
    }),
    getBlockDate() {
      let shuttleBusInfor = {}
      if (this.isAfter) {
        let blockDate = moment(_.get(this.hotelInfo, 'blockdate', new Date())).format('ddd')
        this.setFlightDate(moment(_.get(this.hotelInfo, 'blockdate', new Date())).format('dddd'))
        let operatingTime = this.hotelInfo['operating_time'] || []
        for (let [index, data] of operatingTime.entries()) {
          if (this.day[index] === blockDate) {
            shuttleBusInfor = data.data
          }
        }
      }
      return shuttleBusInfor
    },
    isCheckBlockDate() {
      if (Array.isArray(this.getBlockDate)) {
        return !this.getBlockDate.every((x) => Object.values(x).every((value) => value === null || value === ''))
      }
      return false
    },
    getAddressHotel() {
      return `${this.hotelInfo.address || ''}, ${this.hotelInfo.zipcode || ''}, ${this.hotelInfo.city || ''}, ${
        this.hotelInfo.country || ''
      }`
    },
    getOptionTaxi() {
      if (!this.listDataBooking.length) return ''
      if (this.listDataBooking[0].origin.display_address === this.hotelInfo.address) {
        return 'from the airport'
      } else {
        return 'from the hotel'
      }
    },
    formatTime() {
      return this.direction == 'ltr' ? 'DD-MMM-YYYY' : 'MMM-YYYY-DD'
    },
    formatDateRoom() {
      return this.direction == 'ltr' ? 'DD MMM YYYY' : 'MMM YYYY DD'
    },
    timeOpenClose() {
      if (this.hotelInfo && this.hotelInfo.blockdate && this.hotelInfo.reception_time) {
        let dateBook = new Date(this.hotelInfo.blockdate)
        let day = dateBook.getDay() //  day = 0 => is sunday, day = 6 => is saturday
        // day in js return sunday with value = 0 and monday with value 1
        // day in db retrun sunday with value = 6 and monday with value 0
        if (day === 0) {
          day = 6
        } else {
          day = day - 1
        }
        if (
          !_.isNull(this.hotelInfo.reception_time.regular) &&
          !_.isEmpty(this.hotelInfo.reception_time.regular) &&
          !_.isUndefined(this.hotelInfo.reception_time.regular) &&
          !_.isNull(this.hotelInfo.reception_time.regular[day]) &&
          !_.isEmpty(this.hotelInfo.reception_time.regular[day]) &&
          !_.isUndefined(this.hotelInfo.reception_time.regular[day]) &&
          this.hotelInfo.reception_time.regular[day].open_time &&
          this.hotelInfo.reception_time.regular[day].close_time &&
          this.hotelInfo.reception_time.all_time == 0
        ) {
          return {
            open_time: this.hotelInfo.reception_time.regular[day].open_time,
            close_time: this.hotelInfo.reception_time.regular[day].close_time
          }
        }
      }

      return {
        open_time: '',
        close_time: ''
      }
    },
    checkinInfo() {
      if (this.timeOpenClose.open_time == '' && this.timeOpenClose.close_time == '') {
        return this.formatDate(this.hotelInfo.overnight_date)
      }

      return this.applyTextReplacements(
        this.lang['hotel_mobile_new'].SFS_LANG_ROW_85 || '<checkin_date> between <checkin_opentime> and <checkin_closetime>'
      )
    },
    checkoutInfo() {
      if (!this.hotelInfo.checkout_time) {
        return this.formatDate(this.getOvernightDateEnd())
      }

      return this.applyTextReplacements(this.lang['hotel_mobile_new'].SFS_LANG_ROW_86 || '<checkout_date> at <checkout_time>')
    },
    textReplacements() {
      return {
        '<checkin_date>': this.formatDate(this.checkinDate),
        '<checkin_opentime>': this.timeOpenClose.open_time,
        '<checkin_closetime>': this.timeOpenClose.close_time,
        '<checkout_date>': this.formatDate(this.checkoutDate),
        '<checkout_time>': this.hotelInfo?.checkout_time,
        '<number_person>': this.hotelInfo?.num_paxs ?? '',
        '<hotel_name>': this.hotelInfo?.name ?? '',
        '<airline>': this.airline?.name ?? ''
      }
    },
    getBlockCode() {
      if (this.hotelInfo && this.hotelInfo.more_night && this.hotelInfo.more_night.length) {
        return this.hotelInfo.more_night.map((item) => item.blockcode).join(', ')
      }
      return this.hotelInfo.blockcode
    },
    getRoomType() {
      const { hotelInfo } = this
      if (!hotelInfo) {
        return ''
      }
      const roomTypes = hotelInfo.more_night?.length ? hotelInfo.more_night.map((item) => item.room_type) : [hotelInfo.room_type]
      const uniqueRoomTypes = [...new Set(roomTypes)]
      if (uniqueRoomTypes.length > 1) {
        return hotelInfo.more_night
          .map(
            (item) =>
              `${this.formatDate(item.blockdate, this.formatDateRoom)} ${ROOM_TYPE_MAPPING[item.room_type]?.toLowerCase() || ''}`
          )
          .join('<br/>')
      }
      return ROOM_TYPE_MAPPING[uniqueRoomTypes[0]]
    },
    hotelPhoneNumber() {
      return this.hotelInfo.telephone || this.hotelInfo.ws_booking?.reservationInformation?.hotelPhoneNumber
    },
    hotelOtherServices() {
      try {
        const parsed = JSON.parse(this.hotelInfo?.id_other_service || '{}')

        // Only accept plain objects; reject arrays, null, Date, etc.
        if (Object.prototype.toString.call(parsed) === '[object Object]') {
          return parsed
        }
      } catch (e) {
        console.error('Failed to parse hotelInfo.id_other_service', e)
      }

      return {}
    }
  },
  mounted() {
    if (this.isAfter) {
      return
    }
    this.isShowMap = this.isShowGGMap
  },
  methods: {
    imgDefault(event) {
      event.target.src = this.hotelImageDefault
    },
    handleBookHotel() {
      this.$emit('handleBookHotel', this.hotelInfo)
    },
    showMap(isShow) {
      this.isShowMap = isShow
    },
    setFlightDate(value) {
      this.flightDate = value
    },
    handlePickTime(value) {
      this.$bvModal.hide('pick-up-time')
      this.$emit('confirmPickUpTime', value)
      this.$set(this.timePickup, 'HH', value['HH'] || '00')
      this.$set(this.timePickup, 'mm', value['mm'] || '00')
    },
    formatDate(date, format = this.formatTime) {
      if (!date || !moment(date).isValid()) {
        return ''
      }
      return moment(date).format(format)
    },
    formatDistance(number) {
      return parseFloat(number).toFixed(1)
    },
    getOvernightDateEnd() {
      let overnightDateEnd = ''
      if (!_.isEmpty(this.hotelInfo.overnight_date_end)) {
        overnightDateEnd = moment(this.hotelInfo.overnight_date_end)
      } else {
        overnightDateEnd = moment(this.hotelInfo.overnight_date).add(this.hotelInfo.num_day, 'days')
      }
      return overnightDateEnd.format(this.formatTime)
    },
    applyTextReplacements(str) {
      return replaceStr(str, Object.keys(this.textReplacements), Object.values(this.textReplacements))
    },
    linkify,
    sanitizeHtml
  }
}
</script>

<style lang="scss" scoped>
@mixin important-text {
  line-height: 26pt;
  letter-spacing: -0.3pt;
}

.hotel-card {
  --text-color: #474747;
  .hotel-distance,
  .content__hotel-info {
    font-size: 14pt;
    margin-top: 6pt;
    @include important-text;
    color: var(--text-color);
  }

  .hotel-description {
    padding-bottom: 14pt;
    text-align: justify;
  }

  .btn-select {
    background-color: #05164d;
    color: #fff;
    font-weight: 400;
    padding-top: 6pt;
    padding-bottom: 6pt;
    border-radius: 20px;
    width: 40%;
  }

  .carourel_hotel img {
    max-width: 100%;
    width: 100%;
    max-height: 100%;
  }

  .carourel_hotel .image_carousel {
    display: flex;
    align-items: center;
    background-color: #fff;
  }

  .hotel-horizontal {
    width: 100%;
    height: 1.5px;
    background-color: #ddd;
    border-radius: 10px;
  }

  .hotel-button-select {
    text-align: center;
  }

  .hotel-button-see-more {
    text-decoration: underline;
    color: #545454;
    text-align: center;
    margin-bottom: 24pt;
    a {
      color: #545454;
    }
  }

  .pick-up-time {
    display: flex;
    align-items: center;

    &__value {
      cursor: pointer;
      --font-size: 24pt;
      border: 0 !important;
      height: var(--font-size);
      font-size: var(--font-size);
      color: var(--text-color);
      text-decoration: underline;
      font-weight: 700;
    }
  }

  .content__hotel-info {
    .hotel-information {
      padding-bottom: 2rem;
    }

    .prefix {
      font-weight: 500;
      white-space: nowrap;
    }

    .text-cancel-hotel {
      opacity: 0.8;
      text-decoration: underline;
      font-size: 13pt;
    }

    a {
      @include important-text;
      text-decoration: underline;
      color: var(--text-color);
    }
    .btn-call-hrs-support {
      border: 1px solid;
      border-radius: 8px;
      display: block;
      padding: 4px 30px;
      text-decoration: none;

      i {
        margin-right: 6px;
        color: #5ced73;
      }
    }
  }
  .line-original {
    white-space: pre-line;
  }

  .hotel-comment ::v-deep {
    a {
      font-size: inherit;
      color: var(--text-color);
      text-decoration: underline;
    }
  }

  .text-underline {
    text-decoration: underline;
  }

  .text-blockcode {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
